import React from "react";
import "../../Settings/securityToast.css";

function splitPasswordSuccessMessage(message) {
  const dotSpace = message.indexOf(". ");
  if (dotSpace === -1) {
    return { primary: message, secondary: null };
  }
  return {
    primary: message.slice(0, dotSpace + 1).trim(),
    secondary: message.slice(dotSpace + 2).trim(),
  };
}

function PasswordUpdateSuccessToast({ message }) {
  const { primary, secondary } = splitPasswordSuccessMessage(message);
  return (
    <div className="password-update-toast-inner">
      <p className="password-update-toast-primary">{primary}</p>
      {secondary ? (
        <p className="password-update-toast-secondary">{secondary}</p>
      ) : null}
    </div>
  );
}

export default PasswordUpdateSuccessToast;
